import { defineStore } from "pinia";
import XLSX from "xlsx-js-style"
import { useToast } from 'vue-toastification';
const toast = useToast();

export const useExportStore = defineStore("export", {
    state: () => {
        return {
            loadings: false,
            BORDER_ALL_HEADER: { border: { top: { style: 'thick', color: { rgb: 'f0b90b' } }, right: { style: 'thick', color: { rgb: 'f0b90b' } }, bottom: { style: 'thick', color: { rgb: 'f0b90b' } }, left: { style: 'thick', color: { rgb: 'f0b90b' } } } },
            BORDER_ALL_BODY: { border: { top: { style: 'thick', color: { rgb: 'f0b90b' } }, right: { style: 'thick', color: { rgb: 'f0b90b' } }, bottom: { style: 'thick', color: { rgb: 'f0b90b' } }, left: { style: 'thick', color: { rgb: 'f0b90b' } } } },
            ALIGNMENT_ALL: { alignment: { vertical: 'center', horizontal: 'center', wrapText: true } },
            FONT_EXCHANGE_NAME: { font: { color: { rgb: 'ffffff' }, sz: 20, bold: true } },
            FONT_ALL_HEADER: { font: { color: { rgb: 'ffffff' }, bold: true } },
            FONT_ALL_BODY: { font: { color: { rgb: '000000' }, bold: false } },
            BG_EXCHANGE_NAME: { fill: { fgColor: { rgb: '000000' } } },
            BG_ALL_HEADER: { fill: { fgColor: { rgb: 'f0b90b' } } },
            BG_ALL_BODY: { fill: { fgColor: { rgb: 'ffffff' } } },
            BG_LINE: { fill: { fgColor: { rgb: 'cccccc' } } },
            counter: 0
        };
    },

    getters: {
    },

    actions: {
        export(data) {
            return new Promise((resolve, reject) => {
                var AOA = []
                const wb = XLSX.utils.book_new();
                const headers = Object.keys(data[0])
                let row1 = []
                for (let i = 0; i < headers.length; i++) {
                    if (i == 0)
                        row1.push({ v: "", s: { ...this.BG_EXCHANGE_NAME, ...this.ALIGNMENT_ALL, ...this.FONT_EXCHANGE_NAME, border: { left: { style: 'thick', color: { rgb: 'f0b90b' } } } } })
                    else if (i == headers.length - 1)
                        row1.push({ v: "", s: { ...this.BG_EXCHANGE_NAME, ...this.ALIGNMENT_ALL, ...this.FONT_EXCHANGE_NAME }, border: { right: { style: 'thick', color: { rgb: 'f0b90b' } } } })
                    else if (i == parseInt((headers.length - 1) / 2))
                        row1.push({ v: "CFunded", s: { ...this.BG_EXCHANGE_NAME, ...this.ALIGNMENT_ALL, ...this.FONT_EXCHANGE_NAME } },)
                    else
                        row1.push({ v: "", s: { ...this.BG_EXCHANGE_NAME, ...this.ALIGNMENT_ALL, ...this.FONT_EXCHANGE_NAME } },)
                }
                AOA.push(row1)
                let row2 = headers.map(item => {
                    return { v: item, s: { ...this.BG_ALL_HEADER, ...this.BORDER_ALL_HEADER, ...this.FONT_ALL_HEADER, ...this.ALIGNMENT_ALL } }
                })
                AOA.push(row2)
                data.forEach(element => {
                    let row3 = [];
                    Object.values(element).forEach(elmnt => {
                        row3.push({ v: elmnt, s: { ...this.BG_ALL_BODY, ...this.BORDER_ALL_BODY, ...this.FONT_ALL_BODY, ...this.ALIGNMENT_ALL } })
                    })
                    AOA.push(row3)
                });
                const ws = XLSX.utils.aoa_to_sheet(AOA);
                ws['!cols'] = [{ width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }]
                ws['!rows'] = [{ 'hpt': 35 }, { 'hpt': 30 }]
                XLSX.utils.book_append_sheet(wb, ws, `excel${this.counter}`);
                XLSX.writeFile(wb, "Cfunded_excel.xlsx");
                this.counter++
                toast.success("Export Success");
                resolve()
            });
        }
    },
});